import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { XCircle } from "lucide-react";

export const LoseDialog = ({
  open,
  onOpenChange,
  motivoPerdida,
  setMotivoPerdida,
  onConfirm,
}) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="bg-[#0F0F3D] border-[#1E1E5F] text-white">
      <DialogHeader>
        <DialogTitle className="text-xl text-red-400">
          <XCircle className="h-6 w-6 inline mr-2" />
          Marcar como Perdida
        </DialogTitle>
      </DialogHeader>
      <div className="space-y-4 mt-4">
        <div>
          <Label className="text-slate-300">Motivo de la pérdida</Label>
          <Textarea
            value={motivoPerdida}
            onChange={(e) => setMotivoPerdida(e.target.value)}
            placeholder="Ej: Precio muy alto, eligió competencia..."
            rows={3}
            className="bg-[#0A0A35] border-[#1E1E5F] text-white"
          />
        </div>
        <div className="flex justify-end gap-3">
          <Button variant="outline" onClick={() => onOpenChange(false)} className="border-[#1E1E5F] text-slate-300">
            Cancelar
          </Button>
          <Button onClick={onConfirm} className="bg-red-500 text-white">
            Confirmar Pérdida
          </Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
);
